import type { AzureToken } from "../interfaces/token.interface";
import { HttpHeaders } from "@angular/common/http";

export function GetHttpHeaders(token: AzureToken) {
    return new HttpHeaders()
        .set("Authorization", "Bearer " + token.access_token)
        .set("Content-Type", "application/json; odata.metadata=minimal")
        .set("Prefer", "return=representation")
        .set("Cache-Control", "no-cache");
}

export function GetHttpHeadersSimple(token: AzureToken) {
    return new HttpHeaders().set("Authorization", "Bearer " + token.access_token).set("Cache-Control", "no-cache");
}
